import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  container: {
    padding: '4px 10px 0',
    marginBottom: '-15px',
  },
  navRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '2px',
  },
  monthLabel: {
    fontSize: '13px',
    fontWeight: 600,
    color: '#ffffffee',
    textTransform: 'capitalize',
  },
  weekRow: {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
    gap: '2px',
    marginBottom: '2px',
  },
  weekDay: {
    textAlign: 'center',
    fontSize: '10px',
    color: '#ffffff88',
    fontWeight: 600,
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
    gap: '2px',
  },
  dayCell: {
    position: 'relative' as any,
    height: '24px',
    borderRadius: '5px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '11px',
    fontWeight: 500,
    color: '#ffffff99',
    cursor: 'pointer',
    transition: 'all 0.15s',
    '&:hover': {
      transform: 'scale(1.1)',
      zIndex: 1,
    },
  },
  empty: {
    cursor: 'default',
    '&:hover': {
      transform: 'none',
    },
  },
  neutral: {
    background: '#ffffff0a',
  },
  positive: {
    background: '#4BDC4B30',
    color: '#4BDC4B',
    fontWeight: 600,
    '&:hover': {
      background: '#4BDC4B50',
      transform: 'scale(1.1)',
    },
  },
  negative: {
    background: '#FF634730',
    color: '#FF6347',
    fontWeight: 600,
    '&:hover': {
      background: '#FF634750',
      transform: 'scale(1.1)',
    },
  },
  today: {
    boxShadow: '0 0 0 1.5px #ffee58',
  },
  summary: {
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: '4px',
    padding: '4px 0 0',
    borderTop: '1px solid #ffffff15',
  },
  summaryItem: {
    textAlign: 'center',
  },
  summaryValue: {
    fontSize: '14px',
    fontWeight: 600,
  },
  summaryLabel: {
    fontSize: '11px',
    color: '#ffffff88',
  },
  popover: {
    padding: '12px 16px',
    background: '#23284B',
    borderRadius: '10px',
    border: '1px solid #ffffff15',
  },
});
